import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const { themeConfig } = useTheme();
  const [themeImageUrl, setThemeImageUrl] = useState(null);
  
  // Load theme image
  useEffect(() => {
    const loadThemeImage = async () => {
      if (themeConfig?.theme_image) {
        try {
          const response = await fetch(`${BACKEND_URL}/api/themes/image/${themeConfig.theme_image}`);
          if (response.ok) {
            const blob = await response.blob();
            setThemeImageUrl(URL.createObjectURL(blob));
          }
        } catch (error) {
          console.error('Error loading theme image:', error);
        }
      } else {
        setThemeImageUrl(null);
      }
    };
    loadThemeImage();
    return () => {
      if (themeImageUrl) URL.revokeObjectURL(themeImageUrl);
    };
  }, [themeConfig?.theme_image]);

  // Footer uses PRIMARY color (same as hero)
  const footerBg = themeConfig?.theme?.primary || '#003366';
  const footerText = themeConfig?.theme?.footerText || '#d1d5db';

  return (
    <footer style={{ backgroundColor: footerBg, color: footerText }} className="relative">
      {/* Theme image centered in footer with transparency */}
      {themeImageUrl && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <img 
            src={themeImageUrl}
            alt="Tema"
            className="h-full max-h-64 object-contain opacity-20"
          />
        </div>
      )}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_419069bb-d46c-413f-9dd8-09d0cbbf3735/artifacts/rwf0qmt2_LOGO.png" 
                alt="TÔ INDO ALI" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-white">TÔ INDO ALI</h3>
                <p className="text-sm opacity-70">Turismo e Aventura</p>
              </div>
            </div>
            <p className="text-sm mb-4 max-w-md opacity-90">
              Agência especializada em turismo de aventura, ecoturismo e expedições. 
              Oferecemos experiências únicas e inesquecíveis pelo Brasil e América Latina.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/people/toindoalitur/100028262363593/" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/toindoali.tur/" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Links Rápidos</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:opacity-70 transition-opacity text-sm">Início</Link></li>
              <li><Link to="/pacotes" className="hover:opacity-70 transition-opacity text-sm">Pacotes</Link></li>
              <li><Link to="/sobre" className="hover:opacity-70 transition-opacity text-sm">Sobre Nós</Link></li>
              <li><Link to="/contato" className="hover:opacity-70 transition-opacity text-sm">Contato</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href="tel:+5521979652791" className="hover:opacity-70 transition-opacity text-sm">(21) 97965-2791</a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <a href="mailto:contato@toindoali.com.br" className="hover:opacity-70 transition-opacity text-sm break-all">contato@toindoali.com.br</a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">Rio de Janeiro, RJ</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>
          <p className="text-sm opacity-70">© {new Date().getFullYear()} TÔ INDO ALI - Turismo e Aventura. Todos os direitos reservados.</p>
          <p className="text-xs opacity-50 mt-2">
            <a href="https://cadastur.turismo.gov.br/cadastur/#!/public/qrcode/46231427000100" target="_blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity underline">
              Cadastur: 46.231.427/0001-00
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;